module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('footer', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "href": "https://purpledrapes.atlassian.net/servicedesk/customer/portal/2",
      "target": "_blank"
    }
  }, [_c('icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "name": "question-circle"
    }
  }), _vm._v(" Get help\n    ")], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27cf4f94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterView.vue
// module id = 1003
// module chunks = 1